import { AuthConfig } from '@auth0/auth0-angular';

export const environment = {
  production: true,
  apiBaseUrl: 'https://api.market.agents.jplus.io',
  isAuditFlowEnabled: false,
  authConfig: {
    domain: 'jellyfish.eu.auth0.com',
    clientId: 'ZrIQxJotxwYz3KGx2GWjDBW4PTmNJwVf',
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    audience: '',
    scope: 'openid profile email',
    authorizationParams: {
      redirect_uri: `${window.location.origin}/auth-callback`,
    },
    errorPath: '/access-denied',
  } as AuthConfig,
};
